import React from "react";
import { Helmet } from "react-helmet-async";
export default function TermsPage() {
  return (
    <section className="section container" style={{ paddingTop: "8rem" }}>
      <h1 className="section__title section__title-gradient">Terms of Service</h1>

      <div style={{ lineHeight: "2rem" }}>
        <p>
          <strong>Last updated:</strong> 2025-12-28
        </p>

        <h2 style={{ marginTop: "2rem" }}>1) Agreement to Terms</h2>
        <p>
          By accessing or using Topgun Aviation Academy (the “Service”), you agree
          to these Terms. If you do not agree, do not use the Service. [web:260]
        </p>

        <h2 style={{ marginTop: "2rem" }}>2) The Service</h2>
        <p>
          The Service provides military aviation content and community features such
          as profiles, favorites, ratings, and comments.
        </p>

        <h2 style={{ marginTop: "2rem" }}>3) Accounts</h2>
        <p>
          If you create an account, you are responsible for maintaining the
          confidentiality of your account and for activities that occur under it. [web:260]
        </p>

        <h2 style={{ marginTop: "2rem" }}>4) User Content</h2>
        <p>
          If you submit content (such as comments or ratings), you represent that
          you have the necessary rights to submit it and that it does not violate
          any laws or third-party rights. [web:260]
        </p>
        <p>
          You grant us a non-exclusive, worldwide license to host, store, display,
          and distribute your submitted content for operating and improving the
          Service. [web:260]
        </p>

        <h2 style={{ marginTop: "2rem" }}>5) Acceptable Use</h2>
        <ul>
          <li>Do not misuse the Service, interfere with it, or access it using methods other than the interface provided.</li>
          <li>Do not attempt unauthorized access to systems or user data.</li>
          <li>Do not post unlawful, harmful, or infringing content.</li>
        </ul>

        <h2 style={{ marginTop: "2rem" }}>6) Intellectual Property</h2>
        <p>
          The Service, including its design, logos, and original content, is owned
          by us or our licensors and is protected by applicable laws. [web:260]
        </p>

        <h2 style={{ marginTop: "2rem" }}>7) Third‑Party Services</h2>
        <p>
          The Service may include links to third‑party services (such as the App Store).
          We are not responsible for third‑party content or practices. [web:260]
        </p>

        <h2 style={{ marginTop: "2rem" }}>8) Disclaimers</h2>
        <p>
          The Service is provided “as is” and “as available.” We do not guarantee
          that the Service will be uninterrupted or error‑free. [web:260]
        </p>

        <h2 style={{ marginTop: "2rem" }}>9) Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by law, we will not be liable for indirect,
          incidental, or consequential damages arising from your use of the Service. [web:260]
        </p>

        <h2 style={{ marginTop: "2rem" }}>10) Termination</h2>
        <p>
          We may suspend or terminate access to the Service if you violate these
          Terms or to protect the Service and its users. [web:260]
        </p>

        <h2 style={{ marginTop: "2rem" }}>11) Changes to Terms</h2>
        <p>
          We may update these Terms from time to time. Continued use after changes
          means you accept the updated Terms. [web:260]
        </p>

        <h2 style={{ marginTop: "2rem" }}>12) Contact</h2>
        <ul>
          <li><strong>Email:</strong> support@yourdomain.com</li>
          <li><strong>Developer/Company:</strong> Topgun</li>
        </ul>
      </div>
    </section>
  );
}
